import { UploadedFile } from '../../hooks/file-uploads/types';

export const isDescendantOfFolder = (
  itemId: string,
  targetFolderId: string,
  allFiles: UploadedFile[],
): boolean => {
  if (itemId === targetFolderId) {
    return true;
  }

  const targetFolder = allFiles.find(file => file.id === targetFolderId);
  if (!targetFolder || !targetFolder.isFolder) {
    return false;
  }
  let currentParentId = targetFolder.parentId;

  while (currentParentId) {
    if (currentParentId === itemId) {
      return true;
    }

    const parentFolder = allFiles.find(file => file.id === currentParentId);
    currentParentId = parentFolder?.parentId;
  }

  return false;
};
